var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-bar",class:_vm.display,on:{"showLoadbar":_vm.showLoadBar}},[_c('div',{staticClass:"bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }